export enum ButtonStyleAlignmentEnum {
    left = 'left',
    center = 'center',
    right = 'right'
};
